{
  "lang": "nl",
  "alias": "rijks-cyberscan-den",
  "theme": "rijks-cyberscan",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-errors",
    "a11y-user-detect",
    "actielijst",
    "auto-scroll",
    "change-title-on-tab-blur",
    "chapters-helper",
    "control-filter",
    "custom-radios",
    "end-tools",
    "hacks:label-quotable",
    "has-no-next-meta",
    "headings",
    "history",
    "info-sources",
    "infographics",
    "legacy",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "metadata-change-navtext",
    "metadata-scoring",
    "metaprogress",
    "mis-click-count",
    "nodename-css",
    "non-indenting-jumplist",
    "nonce-metatag",
    "noscript",
    "nta:dynamic-menu-items",
    "nta:mopinion",
    "nta:path-to-modelname",
    "nta:piwik-nonce",
    "nta:proxymap",
    "nta:rijksoverheidshuisstijlfonts",
    "questionlabelgroup-ng",
    "record-link",
    "rijks-ncsc:footer",
    "savecase-auto-continue",
    "savecase-email-link-popup"
  ],
  "overrideinloghtml": "cyberscan-den.html",
  "arbitrary": {
    "core": {
      "scrollToSelectedGroup": false
    },
    "mopinion": {
       "pastease.js": "https://survey-deploy.platformrijksoverheid.nl/js/pastease.js",
       "cybercheck_den": {
        "id": "Dyd2yvA2XWPnhhP5QEC52MBtoSxj9PjFNYzDapFf"
      }
    },
    "piwik": {
      "fallback": {
        "code": "9523ffd3-87c5-41bb-9f98-8278d8f79be2",
        "endpoint": "//statistiek.rijksoverheid.nl/containers/"
      }
    },
    "noscript": {
      "linkstext": "Deze regelhulp vereist JavaScript. Volg, om de regelhulp op een browser zonder JavaScript te doen, een van de volgende links.",
      "links": [
        {
          "url": "open?modelname=cybercheck_den",
          "description": "Cyberscan"
        }
      ]
    },
    "proxymap": {
      "cyberveilig-check-voor-cultuur": {
        "modelname": "cybercheck_den"
      }
    },
    "legacy": {
      "notice": "<h1>Sorry :(</h1>Deze online tool vereist een moderne browser.<br/>Ondersteunde browsers zijn in ieder geval: <ul><li>Laatste (3) versies van Chrome<li>Firefox, huidige ESR (78.15.0esr) of hoger,<li>Chromium-based Edge (vanaf versie 80)<li>Safari versie 13.1 op OSX</ul>Er wordt gewerkt aan support voor Safari op iOS.<br>Internet Explorer en oude Microsoft Edge (tot en met versie 18) worden <strong>niet</strong> ondersteund.<br>Oh, en JavaScript moet aanstaan."
    },
    "savecase-email-link-popup": {
      "location": "https://tools.ncsc.nl/ez/cyberscan-den.html"
    },
    "end-tools": {
      "block": [
        "email"
      ]
    },
    "history": {
      "keepParams": [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_uid"
      ]
    }
  },
  "template": {
    "title": "CyberVeilig Check",
    "change-title-on-tab-blur": {
      "new-title": "Kom je terug voor deel 2?",
      "original-title": "CyberVeilig Check"
    },
    "seo": {
      "description": "Hoe cyberveilig is jouw bedrijf? Doe de CyberVeilig Check voor MKB en ZZP en weet binnen 5 minuten wat je vandaag nog kan (of kunt) doen. Download je eigen actieplan.",
      "keywords": "Cyberscan, cyberveilig check, cyberveiligheid, zzp, mkb, digitale veiligheid",
      "canonical": "https://tools.ncsc.nl/cyberveilig-check-voor-cultuur"
    },
    "auto-scroll": {
      "offset": "0",
      "custom-selector": "span.p-metaprogress"
    },
    "logo-link": "https://www.den.nl/",
    "readonly-prop": "disabled"
  },
  "legacy": false
}
